module.exports = __webpack_public_path__ + "images/151500d36c43e8b9ed51f09680cc6330.png";